/**
 * @generated SignedSource<<a8ee7fca11985981b25339225326def2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateShortLinkInput = {
  clientMutationId?: string | null;
  url: string;
};
export type plansCreateShortLinkMutation$variables = {
  input: CreateShortLinkInput;
};
export type plansCreateShortLinkMutation$data = {
  readonly createShortLink: {
    readonly shortUrl: string;
  } | null;
};
export type plansCreateShortLinkMutation = {
  response: plansCreateShortLinkMutation$data;
  variables: plansCreateShortLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateShortLinkPayload",
    "kind": "LinkedField",
    "name": "createShortLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "plansCreateShortLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "plansCreateShortLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "156062f81c4e0b7feb0f892f321d6676",
    "id": null,
    "metadata": {},
    "name": "plansCreateShortLinkMutation",
    "operationKind": "mutation",
    "text": "mutation plansCreateShortLinkMutation(\n  $input: CreateShortLinkInput!\n) {\n  createShortLink(input: $input) {\n    shortUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea97434ec03b79c6feca487ee68ce43c";

export default node;
